import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "entry-color"
}
const _hoisted_2 = { class: "entry-name" }
const _hoisted_3 = { class: "entry-alias ontos-code text-medium-emphasis" }
const _hoisted_4 = { class: "entry-color" }
const _hoisted_5 = { class: "entry-ident" }
const _hoisted_6 = ["title"]
const _hoisted_7 = { class: "entry-actions" }
const _hoisted_8 = {
  key: 3,
  class: "text-body-2 text-error"
}
const _hoisted_9 = {
  key: 4,
  class: "text-body-2 text-grey"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_header_action = _resolveComponent("ontos-header-action")!
  const _component_ontos_colored_value = _resolveComponent("ontos-colored-value")!
  const _component_ontos_color_swatch_menu = _resolveComponent("ontos-color-swatch-menu")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_ontos_computed_input = _resolveComponent("ontos-computed-input")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_ontos_section = _resolveComponent("ontos-section")!

  return (_openBlock(), _createBlock(_component_ontos_section, {
    title: _ctx.title,
    icon: _ctx.icon,
    level: _ctx.level,
    dense: _ctx.dense,
    divider: _ctx.divider,
    header: _ctx.header
  }, _createSlots({
    actions: _withCtx(() => [
      (_ctx.editable)
        ? (_openBlock(), _createBlock(_component_ontos_header_action, {
            key: 0,
            icon: "mdi-plus",
            label: _ctx.createLabel,
            disabled: _ctx.addDisabled,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.add()))
          }, null, 8, ["label", "disabled"]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "actions", {}, undefined, true)
    ]),
    default: _withCtx(() => [
      (_ctx.list.length && !_ctx.stacked)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["entry-row entry-head", {'entry-row--read': !_ctx.editable}])
          }, [
            (_ctx.editable)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1))
              : _createCommentVNode("", true),
            _createElementVNode("span", {
              class: _normalizeClass(["entry-name", {'required unique': _ctx.editable}])
            }, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$tt('name')), 1)
            ], 2),
            _createElementVNode("span", {
              class: _normalizeClass(["entry-alias", {'required unique': _ctx.editable}])
            }, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$tt('alias')), 1)
            ], 2),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
              return (_openBlock(), _createElementBlock("span", {
                key: column.key,
                class: "entry-column",
                style: _normalizeStyle(_ctx.widthOf(column))
              }, [
                _createElementVNode("label", null, _toDisplayString(column.label), 1)
              ], 4))
            }), 128))
          ], 2))
        : _createCommentVNode("", true),
      (!_ctx.editable)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.entries, (entry, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: entry.alias || index,
              class: "entry-row entry-row--read"
            }, [
              _createElementVNode("span", _hoisted_2, [
                _createVNode(_component_ontos_colored_value, {
                  option: {id: index, name: entry.name, color: _ctx.colors[index]},
                  form: _ctx.form
                }, null, 8, ["option", "form"])
              ]),
              _createElementVNode("span", _hoisted_3, _toDisplayString(entry.alias), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: column.key,
                  class: "entry-column",
                  style: _normalizeStyle(_ctx.widthOf(column))
                }, [
                  _renderSlot(_ctx.$slots, `cell-${column.key}`, {
                    entry: entry,
                    index: index,
                    editable: false
                  }, undefined, true)
                ], 4))
              }), 128))
            ]))
          }), 128))
        : (_openBlock(), _createBlock(_component_draggable, {
            key: 2,
            modelValue: _ctx.rows,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.rows) = $event)),
            "item-key": "__key",
            handle: ".ontos-grip",
            "ghost-class": "ontos-drop-ghost",
            disabled: !_ctx.reorderable,
            onEnd: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changed('reorder')))
          }, {
            item: _withCtx(({element: row, index}) => [
              _createElementVNode("div", {
                class: _normalizeClass(["entry-row", {'entry-row--stacked': _ctx.stacked}])
              }, [
                _createElementVNode("span", _hoisted_4, [
                  _createVNode(_component_ontos_color_swatch_menu, {
                    "model-value": row.color || '',
                    fallback: _ctx.colors[index],
                    used: _ctx.usedColors,
                    clearable: _ctx.automaticColor,
                    title: _ctx.$tt('color'),
                    "onUpdate:modelValue": ($event: any) => (_ctx.setColor(row, $event))
                  }, null, 8, ["model-value", "fallback", "used", "clearable", "title", "onUpdate:modelValue"])
                ]),
                _createElementVNode("span", _hoisted_5, [
                  _createVNode(_component_v_text_field, {
                    "model-value": row.name,
                    autofocus: row.__added,
                    density: "compact",
                    variant: "underlined",
                    "hide-details": "auto",
                    class: "entry-name",
                    "error-messages": _ctx.shown(row, _ctx.errors[index].name),
                    onBlur: ($event: any) => (_ctx.touched[row.__key] = true),
                    "onUpdate:modelValue": ($event: any) => (_ctx.change(row, {name: $event}))
                  }, null, 8, ["model-value", "autofocus", "error-messages", "onBlur", "onUpdate:modelValue"]),
                  (row.__stored)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "entry-alias ontos-code text-medium-emphasis",
                        title: _ctx.$tt('alias')
                      }, _toDisplayString(row.alias), 9, _hoisted_6))
                    : (_openBlock(), _createBlock(_component_ontos_computed_input, {
                        key: 1,
                        dense: "",
                        "hide-details": "auto",
                        class: "entry-alias ontos-code",
                        value: row.alias,
                        source: row.name,
                        manual: !!_ctx.manual[row.__key],
                        "onInput:manual": ($event: any) => (_ctx.manual[row.__key] = $event),
                        compute: _ctx.$utils.aliasSuggestion,
                        "compute-on-input": _ctx.$utils.incompleteAliasSuggestion,
                        "error-messages": _ctx.shown(row, _ctx.errors[index].alias),
                        onBlur: ($event: any) => (_ctx.touched[row.__key] = true),
                        onInput: ($event: any) => (_ctx.change(row, {alias: $event}))
                      }, null, 8, ["value", "source", "manual", "onInput:manual", "compute", "compute-on-input", "error-messages", "onBlur", "onInput"]))
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: column.key,
                    class: "entry-column",
                    style: _normalizeStyle(_ctx.widthOf(column))
                  }, [
                    _renderSlot(_ctx.$slots, `cell-${column.key}`, {
                      entry: row,
                      index: index,
                      editable: true,
                      entries: _ctx.rows,
                      set: _ctx.setter(row),
                      commit: _ctx.emitEntries
                    }, undefined, true)
                  ], 4))
                }), 128)),
                _createElementVNode("span", _hoisted_7, [
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    icon: "",
                    size: "small",
                    color: "error",
                    title: _ctx.$tt('delete'),
                    onClick: ($event: any) => (_ctx.remove(row))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                          _createTextVNode("mdi-delete-outline", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["title", "onClick"]),
                  (_ctx.reorderable)
                    ? (_openBlock(), _createBlock(_component_v_icon, {
                        key: 0,
                        size: "small",
                        class: "ontos-grip text-medium-emphasis"
                      }, {
                        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                          _createTextVNode("mdi-drag", -1)
                        ]))]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ], 2)
            ]),
            _: 3
          }, 8, ["modelValue", "disabled"])),
      (_ctx.minError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.minError), 1))
        : (!_ctx.list.length && _ctx.emptyText)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.emptyText), 1))
          : _createCommentVNode("", true)
    ]),
    _: 2
  }, [
    (_ctx.$slots.title)
      ? {
          name: "title",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "title", {}, undefined, true)
          ]),
          key: "0"
        }
      : undefined,
    (_ctx.$slots.subtitle)
      ? {
          name: "subtitle",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "subtitle", {}, undefined, true)
          ]),
          key: "1"
        }
      : undefined
  ]), 1032, ["title", "icon", "level", "dense", "divider", "header"]))
}